<template>
  <div class="zj-moble-app-page">
    <div class="zj-mt-content">
      <div class="store_wrap" >
          <img class="store_img"  :src="business_icon"  />
          <div class="store_name">{{business_Name}}</div>
      </div>
      <div>
        <div class="pay_num">￥{{money}}</div>
        <div class="submit_btn" @click="PayMoney" v-if="this.Msg==''"><el-button>确认支付</el-button></div>
      </div>
    </div>
    <div class="zj-mt-footer">
        <div class="key_single">
             <el-button @click="inputkey('1')">1</el-button>
             <el-button @click="inputkey('2')">2</el-button>
             <el-button @click="inputkey('3')">3</el-button>
        </div>
        <div class="key_single">
             <el-button @click="inputkey('4')">4</el-button>
             <el-button @click="inputkey('5')">5</el-button>
             <el-button @click="inputkey('6')">6</el-button>
        </div>
        <div class="key_single">
             <el-button @click="inputkey('7')">7</el-button>
             <el-button @click="inputkey('8')">8</el-button>
             <el-button @click="inputkey('9')">9</el-button>
        </div>
        <div class="key_single">
             <el-button @click="inputkey('.')">.</el-button>
             <el-button @click="inputkey('0')">0</el-button>
             <el-button @click="inputkey('delete')">删除</el-button>
        </div>
    </div>
  </div>
</template>

<script>

// import axios from 'axios';
import WebApis from "../../apis";
import utils from "../../../../../../utils";
import { MessageBox,Indicator } from 'mint-ui';

export default {
  name: "StoryPay",
  controller: "UI",
  action: "StoryPay",
  props: {
    query: {
    }
  },
  data: function() {
    return {
      userAgent:"",
      browser:"",
      Msg:"",
      money:'0',
      openid:"",
      businesscode:"",
      childbusinesscode:"",
      business:"",
      childbusiness:"",
      businesstypes:"",
      business_icon:"",
      business_Name:"",
      PayTypeId:"",
      BusinessState:0,
      Status:"0"
    };
  },
  created() {
    
     this.userAgent=navigator.userAgent.toLowerCase();
    if(this.userAgent.match(/Alipay/i)=="alipay")
      {
          //this.Msg="支付宝浏览器";
          this.PayTypeId="ALI_PRECREATE";
      }
      else if(this.userAgent.match(/MicroMessenger/i)=="micromessenger")
      {
          this.PayTypeId="JSAPI";
      }
      else
      {
          this.Msg="请使用支付宝和微信扫描二维码";
      }
    
    this.businesscode=this.$route.query.businesscode;
    this.childbusinesscode=this.$route.query.childbusinesscode;
    return utils.waitAll([
            () => this.GetBusiness(),
            () => this.GetBusinessType(),
            ()=>this.GetChildusiness()]).then(()=>{
                this.Init();
              });
  },
  methods: {
    Init() {
      this.money='0';
      
      this.business_icon="../../images/testimg.png";

      if(this.business)
      {
        this.business_icon=this.business.BusinessIcon;
        this.business_Name=this.business.BusinessName;
      }

      
      if(this.PayTypeId=="JSAPI")
      {
          this.GetUserOpenId(this.$route.query.code);
      }

      this.Status=this.business.Status;

      if(this.Status!="1")
      {
        this.Msg="该商户账户未被开启";
         MessageBox({
              title: '提示',
              message: this.Msg,
              showCancelButton: true
            });
        return;
      }

      if(this.BusinessState==0)
      {
         this.Msg="该商户未被启用";
         MessageBox({
              title: '提示',
              message: this.Msg,
              showCancelButton: true
            });
        return;
      }

     
      if(this.Msg!="")
      {
         MessageBox({
              title: '提示',
              message: this.Msg,
              showCancelButton: true
            });
      }
    },
    inputkey(inputStr)
    {
        if(inputStr=="delete")
        {
            if(this.money.length>1)
            {
                this.money=this.money.substr(0,this.money.length-1);
            }
            else if(this.money.length==1)
            {
                this.money="0";
            }
            return;
        }

        if(this.money=="0")
        {
            if(inputStr!=".")
            {
                this.money=inputStr;
                return;
            }
        }

        if(this.money.indexOf(".")!=-1 && inputStr==".")
        {
            return;
        }
        
        
        this.money=this.money+inputStr;
    },
    GetBusiness()
    {
      let BusinessSearch = {
          BusinessCode: this.businesscode,
        };
      return new WebApis.BusinessApi()
        .GetItemByBusinessCode(BusinessSearch)
        .then((res) => {
          if (res.data.Data) {
            this.business=res.data.Data;
            this.Status=this.business.Status;
            this.BusinessState=this.business.BusinessState;
          }
        });

    },
    GetBusinessType()
    {
        return new WebApis.BusinessTypeApi()
            .FindAll().then((res) => {
              if (res.data.Data) {
                this.businesstypes=res.data.Data;
              }
            });
    },
    GetBusinessTypeByBusinessId(BusinessTypeId)
    {
      var BusinessTypeName="";

      this.businesstypes.forEach(function(item){
        if(item.BusinessTypeId==BusinessTypeId)
        {
          BusinessTypeName= item.BusinessTypeName;
          return;
        }
      });

      return BusinessTypeName;
    },
    GetChildusiness()
    {
      let ChildBusinessSearch = {
          ChildBusinessCode: this.childbusinesscode,
          BusinessCode:this.businesscode
        };
      return new WebApis.ChildBusinessApi()
        .GetItemByBusinessCodeAndChildBusinessCode(ChildBusinessSearch)
        .then((res) => {
          console.log("获取到的ChildBusiness",res.data.Data);
          if (res.data.Data) {
            this.childbusiness=res.data.Data;
            this.BusinessState=this.childbusiness.BusinessState;
          }
        });

    },
    PayMoney()
    {

      if(this.money<=0)
      {
        MessageBox({
              title: '提示',
              message: '请输入金额!',
              showCancelButton: true
            });
        return;
      }

      if(!this.businesscode)
      {
          MessageBox({
              title: '提示',
              message: '无商户信息无法支付!',
              showCancelButton: true
            });
        return;
      }

      if(this.Msg!="")
      {
        MessageBox({
              title: '提示',
              message: this.Msg,
              showCancelButton: true
            });
        return;
      }

      if(this.PayTypeId=="JSAPI" && this.openid!="")
      {
        this.CreateOrder(this.PayTypeId);
      }

      if(this.PayTypeId=="ALI_PRECREATE")
      {
        this.CreateOrder(this.PayTypeId);
      }
    },
    GetUserOpenId(Code)
    {
      let WxOpenIdSearch={
        code:Code
      }

      return new WebApis.BusinessPayOrderApi()
            .GetOpenId(WxOpenIdSearch).then((res)=>{
                if (res.data) {
                  this.openid=res.data.Data;
                }
            }).catch((e) => {
              console.log(e);
              MessageBox({
                title: '提示',
                message: '获取OpenId失败!',
                showCancelButton: true
              });
              return false;
          });
    },
    CreateOrder(PayTypeId)
    {
      
       Indicator.open({ text: 'Loading...', spinnerType: 'fading-circle' });
      let BusinessPayOrderDTO={
        PayTypeId:PayTypeId,
        PayMoney:parseFloat(this.money),
        UserID:this.openid,
        SaleChannel:"02",
        Remarks:"扫码"+this.businesscode+","+this.childbusinesscode+"商户二维码进行支付",
        Validity:1
      }

      let BusinessType_Id=this.business.BusinessTypeId

      if(this.childbusiness)
      {
          BusinessType_Id=this.childbusiness.BusinessTypeId;
      }

      let BusinessType_Name=this.GetBusinessTypeByBusinessId(BusinessType_Id);

      if(this.childbusiness)
      {
          BusinessType_Name=this.childbusiness.ChildBusinessName+BusinessType_Name;
      }

      let Orderdetail={
        BusinessCode:this.businesscode,
        BusinessName:this.business.BusinessName,
        ChildbusinessCode:this.childbusiness.ChildBusinessCode,
        ChildbusinessName:this.childbusiness.ChildBusinessName,
        BusinessTypeId:this.business.BusinessTypeId,
        BusinessTypeName:BusinessType_Name,
        PersonNum:1,
        DiscountRate:1,
        ProductStandPrice:parseFloat(this.money),
        ProductPrice:parseFloat(this.money),
        SumMoney:parseFloat(this.money*1),
        SaleName:this.childbusiness.ChildbusinessName?this.childbusiness.ChildbusinessName:this.business.BusinessName,
        SaleChannel:"02"
      }
      
      let OrderDetailList=[];
      OrderDetailList.push(Orderdetail);

      let BusinessCodes=[];

      let OrderArgs={
        Order:BusinessPayOrderDTO,
        detiallist:OrderDetailList,
        BusinessCodeList:BusinessCodes
      }

      console.log(OrderArgs);


      return new WebApis.BusinessPayOrderApi().CreateOrder(OrderArgs).then((res)=>{
         if (res.data) {
            if(res.data.RspCode=="1")
            {
              console.log(res.data.Data);

              var result=res.data.Data;

              if(this.PayTypeId=="JSAPI")
              {
                if (typeof WeixinJSBridge == "undefined"){
                  if( document.addEventListener ){
                      document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                  }else if (document.attachEvent){
                      document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady); 
                      document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                  }
                }else{
                  this.onBridgeReady(result);
                }
              }
              else if(this.PayTypeId=="ALI_PRECREATE")
              {
                  window.location.href= result.QRURL;
              }
            }
            else
            {
              MessageBox({
                title: '提示',
                message: '支付失败!',
                showCancelButton: true
              });
              Indicator.close();
            }
          }
      }).catch((e) => {
            console.log("支付失败!",e);
            Indicator.close();
            MessageBox({
                title: '提示',
                message: '支付失败!',
                showCancelButton: true
              });
            return false;
      });
    },
    onBridgeReady(result){
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId":result.sub_appId,     //公众号ID，由商户传入     
              "timeStamp":result.timeStamp,         //时间戳，自1970年以来的秒数     
              "nonceStr":result.nonceStr, //随机串     
              "package":result.package,     
              "signType":result.signType,         //微信签名方式：     
              "paySign":result.paySign //微信签名 
            },
            function(res){
            if(res.err_msg == "get_brand_wcpay_request:ok" ){
            // 使用以上方式判断前端返回,微信团队郑重提示：
                  //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            } 
            
            Indicator.close();
        }); 
      }
  },
  computed: {
   
  }
};
</script>
<style  scoped>
.zj-moble-app-page{
  padding: 20px;
  background-color: #f8f8f8;
}
.store_wrap{
  display: flex;
  align-items: center;
}
.store_img{
  width: 0.6rem;
  height: 0.6rem;
  display: inline-block;
  margin-right: 0.15rem;
  border-radius: 50%;
}

.store_name{
  font-size: 0.3rem;
  color: #333;
}
.pay_num{
  margin-top: 0.2rem;
  padding: 0.4rem;
  background-color: #fff;
  font-size: 0.5rem;
  border-radius: 0.1rem;
  font-weight: bold;
}
.submit_btn{
  width: 100%;
  height: 0.85rem;
  text-align: center;
  line-height: 0.85rem;
  font-size: 0.3rem;
  color: #fff;
  margin-top: 0.4rem;
  border-radius: 0.1rem;
  background-color: #f66c1e;
}
.key_single{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.1rem;
}
.key_single el-button{
  width: 30%;
  height: 1.1rem;
  font-size: 0.34rem;
  text-align: center;
  line-height: 1.1rem;
  border-radius: 0.1rem;
  background-color: #fff;
}
</style>